import styled from "styled-components";
import { Table } from "antd";
import { COLORS, SIZES } from "../../../../../../layout/theme";

export const Line = styled.span`
	position: relative;
	&::before {
		content: "";
		width: 120%;
		background-color: ${COLORS.Grey};
		height: 3px;
		position: absolute;
		z-index: 99;
		top: 50%;
		left: -2px;
	}
`;
export const OfferPrice = styled.span`
	margin-left: 10px;
	color: ${COLORS.Secondary};
	font-size: ${SIZES.level11};
`;
export const Price = styled.span``;

export const ActionButton = styled.button`
	border: none;
	border-radius: 5px;
	background-color: transparent;
	padding: 5px;
	cursor: pointer;
	color: ${COLORS.Primary};

	&:hover {
		background-color: ${COLORS.Grey};
	}
`;

export const AntdTable = styled(Table)`
  margin-top: 20px;

  .ant-table-thead > tr > th {
    background: ${COLORS.Primary};
  }

  .ant-table-row {
    background: ${COLORS.White};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${COLORS.Primary};

    div {
      color: ${COLORS.Primary};
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 20px 0 0 0;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0 20px 0 0;
  }

  }
`;

export const Container = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	${(props) =>
		props.cursor &&
		`
    cursor: ${props.cursor};
`}
`;

export const TableContainer = styled.div`
	.ant-table table {
		background-color: ${COLORS.LightGrey} !important;
	}
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
`;

export const StateContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ColorState = styled.div`
	border-radius: 20px;
	padding: 3px 15px;
	${(props) =>
		props.colorBackground &&
		`
    background-color: ${props.colorBackground};
`}
`;
